import { render, staticRenderFns } from "./BooleanGroup.vue?vue&type=template&id=efccb160&"
import script from "./BooleanGroup.vue?vue&type=script&lang=js&"
export * from "./BooleanGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports